module.exports = __webpack_public_path__ + "static/media/sfc1.470985ff.gif";